import React from "react";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo/orion-logo.png";

export const Loading: React.FC = () => {
 const { t } = useTranslation("global");

 return (
  <div className="fixed inset-0 flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-white to-gray-100 z-50">
   {/* Logo Container with Animation */}
   <div className="relative mb-12 animate-pulse">
    <div className="absolute -inset-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full blur opacity-20 animate-blob" />
    <img src={logo} alt="Orion Twin Logo" className="relative w-48 h-auto" />
   </div>

   {/* Custom Spinner */}
   <div className="relative w-16 h-16 mb-8">
    <div className="absolute w-full h-full border-4 border-gray-200 rounded-full" />
    <div className="absolute w-full h-full border-4 border-t-blue-500 border-r-purple-500 rounded-full animate-spin" />
   </div>

   {/* Loading Text with Gradient */}
   <h2 className="text-3xl font-bold mb-3 bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
    {t("loading.message")}
   </h2>

   {/* Description with Animation */}
   <p className="text-lg text-gray-600 animate-pulse">
    {t("loading.description")}
   </p>

   {/* Decorative Elements */}
   <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-100 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob" />
    <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-100 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000" />
   </div>
  </div>
 );
};
